import Chance from "chance";

const chance = new Chance();

const adjectives = [
    "quick", "bright", "silent", "brave", "clever", "happy", "lazy", "shiny", "bold", "lucky",
    "calm", "eager", "fierce", "gentle", "jolly", "kind", "lively", "mighty", "proud", "witty",
    "zealous", "graceful", "humble", "jovial", "keen", "merry", "noble", "plucky", "quirky", "silly",
    "agile", "brisk", "cheerful", "daring", "elegant", "fearless", "glad", "honest", "inventive", "jumpy",
    "keen", "luminous", "mysterious", "nimble", "optimistic", "peaceful", "quiet", "radiant", "serene", "thoughtful",
    "upbeat", "vibrant", "wise", "youthful", "zany", "adventurous", "bubbly", "charming", "delightful", "energetic",
    "friendly", "generous", "hilarious", "imaginative", "joyful", "knowledgeable", "lovely", "motivated", "nice", "outgoing",
    "polite", "quick-witted", "reliable", "sincere", "trustworthy", "understanding", "valiant", "warm", "xenodochial", "yummy",
    "zealous", "affectionate", "bright-eyed", "courageous", "diligent", "enthusiastic", "faithful", "gentle-hearted", "hopeful", "inquisitive",
    "jovial", "kind-hearted", "light-hearted", "merry-hearted", "noble-hearted", "open-hearted", "positive", "quiet-hearted", "resilient", "strong-hearted",
    "tender-hearted", "upbeat-hearted", "vivid-hearted", "wise-hearted", "young-hearted", "zestful", "amiable", "benevolent", "compassionate", "devoted",
    "empathetic", "forgiving", "gracious", "humorous", "inspiring", "jubilant", "kindly", "loyal", "mindful", "nurturing",
    "optimistic", "patient", "quick-hearted", "respectful", "supportive", "thoughtful", "understanding", "vigilant", "warm-hearted", "xenial",
    "youthful-hearted", "zeal-hearted"
];

const nouns = [
    "apple", "tiger", "rocket", "planet", "castle", "guitar", "dragon", "river", "cloud", "bridge",
    "mountain", "forest", "ocean", "star", "comet", "tree", "flower", "bird", "fish", "lion",
    "elephant", "butterfly", "whale", "dolphin", "wolf", "bear", "fox", "owl", "eagle", "shark",
    "ant", "bee", "cat", "dog", "frog", "goat", "horse", "iguana", "jaguar", "kangaroo",
    "lemur", "monkey", "newt", "octopus", "penguin", "quail", "rabbit", "snake", "turtle", "urchin",
    "vulture", "walrus", "xerus", "yak", "zebra", "airplane", "bicycle", "car", "drone", "elevator",
    "ferry", "glider", "helicopter", "icebreaker", "jet", "kayak", "limousine", "motorcycle", "narrowboat", "orbiter",
    "parachute", "quad", "raft", "scooter", "tractor", "unicycle", "van", "wagon", "xylophone", "yacht",
    "zeppelin", "accordion", "banjo", "cello", "drum", "electric guitar", "flute", "gong", "harp", "instrument",
    "jazz", "keyboard", "lute", "mandolin", "note", "oboe", "piano", "quartet", "recorder", "saxophone",
    "trombone", "ukulele", "violin", "whistle", "xylophone", "yodel", "zither", "amphibian", "bacteria", "cactus",
    "dinosaur", "earthworm", "fungus", "gecko", "heron", "insect", "jellyfish", "koala", "lichen", "mammal",
    "narwhal", "orchid", "panda", "quokka", "reptile", "salamander", "tarantula", "urchin", "viper", "wombat",
    "xerus", "yak", "zebu"
];

const verbs = [
    "jump", "run", "fly", "swim", "climb", "dance", "sing", "write", "build", "draw",
    "read", "cook", "drive", "paint", "play", "laugh", "smile", "think", "dream", "explore",
    "create", "invent", "discover", "imagine", "learn", "teach", "grow", "travel", "watch", "listen",
    "act", "bake", "chop", "dig", "eat", "fish", "gather", "hunt", "jog", "knead",
    "lift", "mow", "navigate", "observe", "plant", "quilt", "row", "sew", "tinker", "unwind",
    "vacuum", "whistle", "yawn", "zip", "analyze", "breathe", "calculate", "decorate", "exercise", "focus",
    "gaze", "hike", "illustrate", "juggle", "knit", "listen", "meditate", "negotiate", "organize", "practice",
    "question", "research", "sketch", "train", "understand", "volunteer", "write", "yodel", "zoom", "arrange",
    "balance", "clean", "design", "experiment", "formulate", "gather", "help", "inspire", "jot", "kneel",
    "learn", "measure", "note", "optimize", "plan", "query", "record", "solve", "test", "update",
    "visualize", "work", "yell", "zip"
];

export function generatePassword(
    useUppercase,
    useNumbers,
    useSymbols,
    passwordLength = 12
) {
    const lowercaseLetters = "abcdefghijklmnopqrstuvwxyz";
    const uppercaseLetters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    const numbers = "0123456789";
    const symbols = "!@#$%^&*()_+~`|}{[]:;?><,./-=";

    let characters = lowercaseLetters;
    if (useUppercase) characters += uppercaseLetters;
    if (useNumbers) characters += numbers;
    if (useSymbols) characters += symbols;

    const password = [];
    for (let i = 0; i < passwordLength; i++) {
        password.push(
            characters.charAt(Math.floor(Math.random() * characters.length))
        );
    }

    // Ensure password includes at least one of each chosen character type
    if (
        useUppercase &&
        !password.some((char) => uppercaseLetters.includes(char))
    ) {
        password[0] = uppercaseLetters.charAt(
            Math.floor(Math.random() * uppercaseLetters.length)
        );
    }
    if (useNumbers && !password.some((char) => numbers.includes(char))) {
        password[1] = numbers.charAt(Math.floor(Math.random() * numbers.length));
    }
    if (useSymbols && !password.some((char) => symbols.includes(char))) {
        password[2] = symbols.charAt(Math.floor(Math.random() * symbols.length));
    }

    return password.join("");
}

export function generatePassphrase(numWords, separator) {
    const words = [];
    for (let i = 0; i < numWords; i++) {
        const wordType = chance.pickone([adjectives, nouns, verbs]);
        words.push(chance.pickone(wordType));
    }
    return words.join(separator);
}